export enum PlacementFieldsType {
  PlacementTransitions = "PlacementTransitions",
  Underwriting = "Underwriting",
  WidgetDropOff = "WidgetDropOff",
  WidgetFinished = "WidgetFinished",
}
